import gql from 'graphql-tag';

export const addGoalComment = gql`
  mutation AddGoalComment($input: GoalCommentInput, $userID: String!) {
    addGoalComment(input: $input, userID: $userID)
  }
`;
